<template>
  <div class="zoox-component zoox-credit-card">
    <z-physical-card
      has-cvv
      :cvv="cvvWithMask"
      :expiration-year="expirationYear"
      :expiration-month="expirationMonth"
      :number="number"
      :name="name"
    >
      <template #logo>
        <img :src="cardTypeImage" />
      </template>
    </z-physical-card>
  </div>
</template>

<script>
import {getCreditCardFlag} from './utils'

/**
 * @displayName Payment Card
 */
export default {
  name: 'ZPaymentCard',
  props: {
    /**
     * Nome do títular do cartão
     */
    name: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Número do cartão
     */
    number: {
      type: [Number, String],
      required: false,
      default: '',
    },
    /**
     * Mês de expiração do cartão
     */
    expirationMonth: {
      type: [Number, String],
      required: false,
      default: '',
    },
    /**
     * Ano de expiração do cartão
     */
    expirationYear: {
      type: [Number, String],
      required: false,
      default: '',
    },
    /**
     * CVV do cartão
     */
    cvv: {
      type: [Number, String],
      required: false,
      default: '',
    },
  },
  computed: {
    cvvWithMask() {
      const result = []
      const cvvString = this.cvv.toString()

      for (let i = 0; i < 3; ++i) {
        if (typeof cvvString[i] === 'undefined') {
          result.push('#')
        } else {
          result.push(cvvString[i])
        }
      }

      return result.join('')
    },

    cardType() {
      const number = this.number.toString()

      return getCreditCardFlag(number)
    },
    cardTypeImage() {
      return require(`../../../assets/img/card/${this.cardType}.png`)
    },
  },
}
</script>
